module.exports = __webpack_public_path__ + "static/slider3-a7710992041e8beaaa84b7eabb15af80.jpg";